import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';

const BulkUploadActionsMenu = ({ row }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadFile = async (downloadType) => {
    try {
      dispatch(showSnackbar({ message: "Downloading...", severity: 'info' }));

      const response = await apiClient.get(`/bulk-uploads/${row.id}/download`, {
        params: { downloadType },
        responseType: 'blob', // important for file downloads
        headers: {
          'Content-Type': undefined, // override default JSON
        },
      });

      const fileData = response.data;

      if (!(fileData instanceof Blob) || fileData.size === 0) {
        throw new Error('Empty file received');
      }

      const headers = response.headers || {};
      const xFilename =
        typeof headers['x-suggested-filename'] === 'string'
          ? headers['x-suggested-filename']
          : Array.isArray(headers['x-suggested-filename'])
            ? headers['x-suggested-filename'][0]
            : undefined;

      const finalFileName = xFilename || `${downloadType}_report.xlsx`;

      const downloadUrl = window.URL.createObjectURL(fileData);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', finalFileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      dispatch(showSnackbar({ message: "File downloaded successfully!", severity: 'success' }));
    } catch (error) {
      console.error('Download error:', error);
      dispatch(
        showSnackbar({
          message: "Error downloading file. Please try again later.",
          severity: 'error',
        }),
      );
    } finally {
      handleClose();
    }
  };

  const actionsDisabled = row.status === 'UPLOADED' || row.status === 'PROCESSING' || row.status === 'UPLOAD_FAILED';

  return (
    <>
      <IconButton onClick={handleClick} disabled={actionsDisabled}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              boxShadow: '4px 4px 10px 0px rgba(0,0,0,0.2)',
            },
          },
        }}
      >
        {row.error_documents_count > 0 && (
          <MenuItem onClick={() => handleDownloadFile('error')}>
            {'Error Report'}
          </MenuItem>
        )}
        <MenuItem onClick={() => handleDownloadFile('log')}>{'Logs'}</MenuItem>
        {row.processed_documents_count > 0 && (
          <MenuItem onClick={() => handleDownloadFile('success')}>
            {'Success Report'}
          </MenuItem>
        )}
        <MenuItem onClick={() => handleDownloadFile('original')}>
          {'Original File'}
        </MenuItem>
      </Menu>
    </>
  );
};

export default BulkUploadActionsMenu;
